import { styled, disabledProps } from "webapp/styled-components";

export const SignatureStyle = styled.div`
    flex-grow: 1;
    display: flex;
    flex-direction: column;

    .s-clear-button {
        position: absolute;
        height: 44px;
        bottom: 16px;
        left: 50%;
        transform: translateX(-50%);
        ${p => p.theme.fontStyles.Subheader4}
        color: ${p => p.theme.primaryAccentColor};

        cursor: pointer;
    }

    .disabled {
        ${disabledProps}
        cursor: unset;
        pointer-events: auto;
    }
`;
